import React, { FunctionComponent } from "react";
import { Footer as LcFooter } from "@purpledeerstudio/logistics-components";
import { FooterUrls } from "../../../config/urls";

const Footer: FunctionComponent<{ isLightFooter: boolean }> = ({ isLightFooter }) => {
  return <LcFooter urls={FooterUrls} variant={isLightFooter ? "light" : "dark"} />;
};

export default Footer;
